'use strict';

import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import DefaultModal from 'Modals/DefaultModal';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import CustomerIcon from 'Icons/CustomerIcon';
import CompanyUserIcon from 'Icons/CompanyUserIcon';
import AdminUserIcon from 'Icons/AdminUserIcon';
import DropdownIcon from 'Icons/Dropdown';
import { URL } from 'Shared/Routes';
import bemit from 'Functions/bemit';
const app = window.app;
const qwest = window.qwest;
export default class FrontHeader extends Component {
  state = {
    open: false,
    login_modal: false,
    is_navbar_open: false
  };
  ref_header = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    app.push({
      event: 'documentClick',
      cb: component.handleDocumentClick
    });
    if (app?.state?.session?.user?.roles?.length > 0) {
      component.handleSessionChange({
        source: 'FrontHeader-DidMount'
      });
    }
    component.setState({
      open: false
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    app.delete({
      event: 'documentClick',
      cb: component.handleDocumentClick
    });
  }
  handleSessionChange = ({
    source,
    data
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app?.state?.session?.user?.roles || []
    });
  };
  openLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      login_modal_trigger: e.target,
      login_modal: true
    });
  };
  requestCustomerLogin = e => {
    const component = this,
      props = this.props,
      state = this.state;
    app.emit({
      event: 'TC_Click',
      source: 'FrontHeader',
      data: {
        e: e,
        action: 'connexion'
      }
    });
    app.navigateTo(URL('CustomerLogin'));
  };
  requestCompanyUserLogin = e => {
    const component = this,
      props = this.props,
      state = this.state;
    app.emit({
      event: 'TC_Click',
      source: 'FrontHeader',
      data: {
        e: e,
        action: 'connexion'
      }
    });
    app.navigateTo(URL('CompanyEmployeeLogin'));
  };
  requestCompanyAdminLogin = e => {
    const component = this,
      props = this.props,
      state = this.state;
    app.emit({
      event: 'TC_Click',
      source: 'FrontHeader',
      data: {
        e: e,
        action: 'connexion'
      }
    });
    app.navigateTo(URL('CompanyLogin'));
  };
  closeLoginModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login_modal_trigger: undefined,
      login_modal: false
    });
  };
  handleLogin = user => {
    const component = this,
      props = this.props,
      state = this.state;

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'loginModal',
      data: {
        url: user.roles?.includes('customer') ? URL('CustomerBookingsDashboard') : user.roles?.includes('hotelier') ? URL('AdminCoworkingSpacesDashboard') : user.roles?.includes('admin') ? URL('AdminEtablishmentsDashboard') : undefined
      }
    });
  };
  captureClick = e => {
    e?.persist();
    e?.stopPropagation();
    app.emit({
      event: 'documentClick',
      source: 'user-menu'
    });
  };
  handleDocumentClick = ({
    source,
    data = {}
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (source === 'user-menu') return;
    component.setState({
      is_navbar_open: false
    });
  };
  toggleNav = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e?.persist();
    e?.stopPropagation();
    app.emit({
      event: 'documentClick',
      source: 'user-menu'
    });
    component.setState({
      is_navbar_open: !component.state.is_navbar_open
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      document.location.pathname = '/';
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const roles = state.roles || [];
    const session_user = app.state.session?.user || {};
    let modifiers = [].concat(state.open ? ['open'] : []);
    if (Array.isArray(props['bemit'])) modifiers = modifiers.concat(props.bemit);
    if (props['hide-navbar'] === true) {
      return /*#__PURE__*/React.createElement("header", {
        className: bemit('o-front-header', modifiers),
        ref: component.ref_header
      }, /*#__PURE__*/React.createElement(Link, {
        href: "/",
        className: "o-front-header__logo-link"
      }, /*#__PURE__*/React.createElement(Logo, {
        className: "o-front-header__logo",
        type: "white"
      })));
    }
    const toggle_icon = state.open !== true ? /*#__PURE__*/React.createElement("svg", {
      className: "o-front-header__toggle-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("line", {
      x1: "3",
      y1: "12",
      x2: "21",
      y2: "12"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "3",
      y1: "6",
      x2: "21",
      y2: "6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "3",
      y1: "18",
      x2: "21",
      y2: "18"
    })) : /*#__PURE__*/React.createElement("svg", {
      className: "o-front-header__toggle-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("line", {
      x1: "18",
      y1: "6",
      x2: "6",
      y2: "18"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "6",
      y1: "6",
      x2: "18",
      y2: "18"
    }));
    let dynamic_buttons;
    if (roles.length === 0) {
      dynamic_buttons = props['hide-login'] ? undefined : /*#__PURE__*/React.createElement("li", {
        className: "c-front-navbar__item"
      }, /*#__PURE__*/React.createElement(Button, {
        className: "c-front-navbar__link",
        component: Link,
        onClick: component.openLoginModal
      }, "Se connecter"));
    } else {
      const url = roles.includes('admin') ? URL('AdminEtablishmentsDashboard') : roles.includes('hotelier') ? URL('AdminCoworkingSpacesDashboard') : roles.includes('customer') ? URL('CustomerBookingsDashboard') : roles.includes('company') ? URL('CompanyInformation') : roles.includes('marketing') ? URL('ExportBtoCMarketingDashboard') : URL('Login');
      const btn_text = roles.includes('customer') ? "Mes réservations" : roles.includes('company') ? "Mon entreprise" : "Mon espace";
      dynamic_buttons = /*#__PURE__*/React.createElement(Fragment, null, !roles.includes('company_employee') ? /*#__PURE__*/React.createElement("li", {
        className: "o-user-menu__item",
        onClick: component.captureClick
      }, /*#__PURE__*/React.createElement(Button, {
        className: "o-user-menu__link",
        component: Link,
        href: url
      }, btn_text)) : undefined, roles.includes('company_employee') ? /*#__PURE__*/React.createElement("li", {
        className: "o-user-menu__item",
        onClick: component.captureClick
      }, /*#__PURE__*/React.createElement(Button, {
        className: "o-user-menu__link",
        component: Link,
        href: URL('EmployeeBookingsDashboard')
      }, "Mes r\xE9servations")) : undefined, roles.includes('customer') ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("li", {
        className: "o-user-menu__item",
        onClick: component.captureClick
      }, /*#__PURE__*/React.createElement(Button, {
        className: "o-user-menu__link",
        component: Link,
        href: URL('WalletCard')
      }, "Ma carte myWO")), /*#__PURE__*/React.createElement("li", {
        className: "o-user-menu__item",
        onClick: component.captureClick
      }, /*#__PURE__*/React.createElement(Button, {
        className: "o-user-menu__link",
        component: Link,
        href: URL('CustomerAccount')
      }, "Mon compte"))) : undefined);
    }
    const nav = session_user?.login && !props['hide-login'] ? /*#__PURE__*/React.createElement("nav", {
      className: bemit('o-user-menu', state.is_navbar_open ? ['open'] : []),
      onClick: component.toggleNav
    }, /*#__PURE__*/React.createElement(Button, {
      className: "o-user-menu__btn",
      onClick: component.toggleNav,
      "aria-label": "Menu utilisateur"
    }, roles.includes('admin') || roles.includes('customer') || roles.includes('hotelier') ? /*#__PURE__*/React.createElement("span", {
      className: "o-user-menu__btn-txt"
    }, /*#__PURE__*/React.createElement(CustomerIcon, null)) : roles.includes('company') ? /*#__PURE__*/React.createElement("span", {
      className: "o-user-menu__btn-txt"
    }, /*#__PURE__*/React.createElement(AdminUserIcon, null)) : /*#__PURE__*/React.createElement("span", {
      className: "o-user-menu__btn-txt"
    }, /*#__PURE__*/React.createElement(CompanyUserIcon, null)), /*#__PURE__*/React.createElement(DropdownIcon, {
      className: "o-user-menu__btn-icon"
    })), /*#__PURE__*/React.createElement("ul", {
      className: "o-user-menu__ul",
      onClick: component.captureClick
    }, dynamic_buttons, /*#__PURE__*/React.createElement("li", {
      className: "o-user-menu__item"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "o-user-menu__link",
      onClick: component.logout
    }, "D\xE9connexion")))) : undefined;
    const navbar = props['hide-login'] ? undefined : /*#__PURE__*/React.createElement("nav", {
      className: "o-front-header__navbar"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "c-front-navbar"
    }, /*#__PURE__*/React.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "c-front-navbar__link",
      href: URL('ConceptPage')
    }, "Notre concept")), !roles.includes('customer') && !roles.includes('company') && !roles.includes("company_employee") && !roles.includes('admin') && !roles.includes('hotelier') && !roles.includes("marketing") && !props['hide-login'] ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "c-front-navbar__link",
      href: URL('CompanyOfferPage')
    }, "Offre entreprise")), /*#__PURE__*/React.createElement("li", {
      className: "c-front-navbar__item"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "c-front-navbar__button-link",
      component: Link,
      onClick: component.openLoginModal
    }, "Se connecter"))) : undefined, nav));
    const navbar_content = navbar ? /*#__PURE__*/React.createElement("div", {
      className: "o-front-header__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-front-header__bottom"
    }, navbar)) : undefined;
    let output = /*#__PURE__*/React.createElement("header", {
      className: bemit('o-front-header', modifiers),
      ref: component.ref_header
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/",
      className: "o-front-header__logo-link"
    }, /*#__PURE__*/React.createElement(Logo, {
      className: "o-front-header__logo",
      type: "white"
    })), props['hide-login'] ? /*#__PURE__*/React.createElement("div", {
      className: "o-front--header__welcome-txt"
    }, roles.includes('company') ? session_user.name : roles.includes('company_employee') ? session_user?.company?.name : ['Bienvenue', [session_user.firstname, session_user.lastname].filter(str => str).join(' ')].join(', ')) : undefined, !props['hide-login'] ? /*#__PURE__*/React.createElement(Button, {
      type: "button",
      className: "o-front-header__toggle",
      onClick: e => component.setState({
        open: !state.open
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-front-header__toggle-label"
    }, "Menu"), toggle_icon) : undefined, navbar_content, /*#__PURE__*/React.createElement(DefaultModal, {
      title: "Connexion",
      "close-ref": component.modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeLoginModal,
      open: state.login_modal,
      trigger_src: state.login_modal_trigger
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "c-login-grid__item",
      onClick: component.requestCustomerLogin
    }, /*#__PURE__*/React.createElement(CustomerIcon, {
      className: "c-login-grid__item-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid__item-title"
    }, "myWO"), /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid__item-subtitle"
    }, "Se connecter \xE0 mon compte personnel")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "c-login-grid__item",
      onClick: component.requestCompanyUserLogin
    }, /*#__PURE__*/React.createElement(CompanyUserIcon, {
      className: "c-login-grid__item-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid__item-title"
    }, "myWO Entreprise"), /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid__item-subtitle"
    }, "J'ai un code entreprise et je r\xE9serve mon espace")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "c-login-grid__item",
      onClick: component.requestCompanyAdminLogin
    }, /*#__PURE__*/React.createElement(AdminUserIcon, {
      className: "c-login-grid__item-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid__item-title"
    }, "Administrateur Entreprise"), /*#__PURE__*/React.createElement("div", {
      className: "c-login-grid__item-subtitle"
    }, "Gestion des comptes collaborateurs et achats de cr\xE9dits")))));
    return output;
  };
}
